import UserPermissionHelper from "./user-permission-helper";


const UserHelpers = {
    permission : UserPermissionHelper
}

export default UserHelpers;